import Head from 'next/head';
import Nav from '@/components/Nav';
import Hero from '@/components/Hero';
import Welcome from '@/components/Welcome';
import Events from '@/components/Events';
import Register from '@/components/Register';
import Footer from '@/components/Footer';

export default function Home() {
  return (
    <>
      <Head>
        <title>Queen of Angels · 50 Years · qoais50.ie</title>
        <meta name="description" content="Queen of Angels Primary School celebrates 50 years — 1976 to 2026. Past pupils, current parents, parishioners and neighbours are all welcome." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <Nav />
      <Hero />
      <Welcome />
      <Events />
      <Register />
      <Footer />
    </>
  );
}
